/**
 * Formats a timestamp string as a human-readable relative time string.
 * Examples: "5 seconds ago", "2 minutes ago", "1 hour ago", "3 days ago"
 */
export function formatRelativeTime(timestamp: string | undefined | null): string {
    if (!timestamp) {
        return "--";
    }

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
        return "--";
    }

    const now = Date.now();
    const diffMs = now - date.getTime();

    if (diffMs < 1000) {
        return "just now";
    }

    const seconds = Math.floor(diffMs / 1000);
    if (seconds < 60) {
        return seconds === 1 ? "1 second ago" : `${seconds} seconds ago`;
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    }

    const days = Math.floor(hours / 24);
    return days === 1 ? "1 day ago" : `${days} days ago`;
}
